import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';
import {navigateTo} from '../../router/actions';

export const getProviderOrderDetail = (orderCode) => apiActionCreator({
  'endpoint': `/orders/providers/administration/${orderCode}`,
  'authenticated': true,
  'types': [
    ActionTypes.GET_PROVIDER_ORDER_DETAIL_REQUEST,
    [
      ActionTypes.GET_PROVIDER_ORDER_DETAIL_SUCCESS,
    ],
    [
      ActionTypes.GET_PROVIDER_ORDER_DETAIL_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const addProviderOrderDetail = (orderCode, data, index) => apiActionCreator({
  'endpoint': `/orders/providers/administration/${orderCode}`,
  'authenticated': true,
  'types': [
    ActionTypes.ADD_PROVIDER_ORDER_DETAIL_REQUEST,
    [
      {
        'type': ActionTypes.ADD_PROVIDER_ORDER_DETAIL_SUCCESS,
        'payload': index,
      },
    ],
    [
      ActionTypes.ADD_PROVIDER_ORDER_DETAIL_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'POST',
  'contentType': 'application/json',
  'data': data,
});

export const deleteProviderOrderDetail = (orderCode, data, index) => apiActionCreator({
  'endpoint': `/orders/providers/administration/${orderCode}`,
  'authenticated': true,
  'types': [
    ActionTypes.DELETE_PROVIDER_ORDER_DETAIL_REQUEST,
    [
      {
        'type': ActionTypes.DELETE_PROVIDER_ORDER_DETAIL_SUCCESS,
        'payload': index,
      },
    ],
    [
      ActionTypes.DELETE_PROVIDER_ORDER_DETAIL_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'DELETE',
  'contentType': 'application/json',
  'data': data,
});

export const editProviderOrderDetail = (orderCode, data, index) => apiActionCreator({
  'endpoint': `/orders/providers/administration/${orderCode}`,
  'authenticated': true,
  'types': [
    ActionTypes.EDIT_PROVIDER_ORDER_DETAIL_REQUEST,
    [
      {
        'type': ActionTypes.EDIT_PROVIDER_ORDER_DETAIL_SUCCESS,
        'payload': index,
      },
    ],
    [
      ActionTypes.EDIT_PROVIDER_ORDER_DETAIL_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'PUT',
  'contentType': 'application/json',
  'data': data,
});

export const viewProviderOrderDetail = (selectedOrder) => (dispatch) => {
  dispatch(navigateTo('/proveedor/gestion-detalle-pedido'));

  return dispatch({
    'type': ActionTypes.VIEW_PROVIDER_ORDER_DETAIL,
    'payload': selectedOrder,
  });
};

export const clearProviderOrderDetail = () => ({
  'type': ActionTypes.CLEAR_SELECTED_PROVIDER_ORDER_DETAIL,
});

export const changeProviderDetailElementValue = (index, field, value) => ({
  'type': ActionTypes.CHANGE_PROVIDER_DETAIL_ELEMENT,
  'payload': {index, field, value},
});

export const editProviderOrderDetailElement = (index) => ({
  'type': ActionTypes.EDIT_ELEMENT_IN_PROVIDER_ORDER_DETAIL,
  'payload': index,
});

export const cancelProviderOrderDetailElementEdition = (index) => ({
  'type': ActionTypes.CANCEL_PROVIDER_ORDER_ELEMENT_EDITION,
  'payload': index,
});

export const addProviderOrderDetailElement = () => ({
  'type': ActionTypes.ADD_ELEMENT_TO_PROVIDER_ORDER_DETAIL,
});

export const removeProviderOrderDetailElement = (index) => ({
  'type': ActionTypes.REMOVE_ELEMENT_FROM_PROVIDER_ORDER_DETAIL,
  'payload': index,
});

export const selectProviderOrderDetailElement = (index) => ({
  'type': ActionTypes.SELECT_PROVIDER_ORDER_DETAIL_ELEMENT,
  'payload': index,
});

export const clearSelectedProviderOrderDetailElement = () => ({
  'type': ActionTypes.CLEAR_SELECTED_PROVIDER_ORDER_DETAIL_ELEMENT,
});
